// import { useState, useEffect } from "react";
// import { loadCityList } from "../services/locationService";
// import { loadEmployeeList } from "../services/employeeService";


// const useEmployee = (editShiftAssignmentID) => {
//     const [employee, setEmployee] = useState([]);
//     const [selectedEmployee, setSelectedEmployee] = useState(null);
//     const [selectedEmployeeID, setSelectedEmployeeID] = useState(null);
//     const [isEmployeeDataLoaded, setIsEmployeeDataLoaded] = useState(false);

//     // Fetch department data
//     const fetchEmployee = async (selectedID = null) => {
//         const para = { p_companyid: localStorage.getItem("companyid") };

//         try {
//             const data = await loadEmployeeList(para);
//             if (data && data.length > 0) {
//                 setEmployee(data);

//                 if (selectedID) {
//                     const initialEmployee = data.find((dept) => dept.id === selectedID) || data[0];
//                     setSelectedEmployee(initialEmployee);
//                     setSelectedEmployeeID(initialEmployee.id);
//                 }

//                 setIsEmployeeDataLoaded(true);
//             }
//         } catch (error) {
//             // CallMessage("error", error.message, "Error");
//         }
//     };

//     // Load departments when the component mounts
//     useEffect(() => {
//         if (!isEmployeeDataLoaded && editShiftAssignmentID === 0) {
//             fetchEmployee();
//         }
//     }, [isEmployeeDataLoaded, editShiftAssignmentID]);

//     // Function to load department based on selected ID
//     const loadEmployeeByID = async (selectedID) => {
//         await fetchEmployee(selectedID);
//     };

//     return {
//         employee,
//         selectedEmployee,
//         selectedEmployeeID,
//         setSelectedEmployee,
//         setSelectedEmployeeID,
//         loadEmployeeByID,
//     };
// };

// export default useEmployee;



import { useState, useEffect } from "react";
import { loadEmployeeList } from "../services/employeeService";

const useEmployee = (defaultSelectedID = null) => {

  const [employee, setEmployee] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedEmployeeID, setSelectedEmployeeID] = useState(null);
  const [isEmployeeDataLoaded, setIsEmployeeDataLoaded] = useState(false);

  const fetchEmployee = async (selectedID = null) => {
    const para = { p_companyid: localStorage.getItem("companyid") };

    try {
      const data = await loadEmployeeList(para);
      if (data && data.length > 0) {
        setEmployee(data);


        const initial = selectedID
          ? data.find((e) => e.id === selectedID)
          : [];

        if (initial) {
          setSelectedEmployee(initial);
          setSelectedEmployeeID(initial.id);
        }

        setIsEmployeeDataLoaded(true);
      }
      else {
        setEmployee([]);
        setSelectedEmployee(null);
        setSelectedEmployeeID(null);
        setIsEmployeeDataLoaded(false);
      }
    } catch (error) {
      console.error("Failed to load employee list:", error);
    }
  };

  useEffect(() => {
    if (!isEmployeeDataLoaded) {
      fetchEmployee(defaultSelectedID);
    }
  }, [defaultSelectedID, isEmployeeDataLoaded]);

  const loadEmployeeByID = async (selectedID) => {
    await fetchEmployee(selectedID);
  };

  return {
    employee,
    selectedEmployee,
    selectedEmployeeID,
    setSelectedEmployee,
    setSelectedEmployeeID,
    loadEmployeeByID,
  };
};

export default useEmployee;
